import { padStart } from 'lodash'
import { parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
  install (Vue) {
    Vue.filter('nullable', (value) => {
      return (value === null || value === undefined || value === '') ? '–' : value
    })

    Vue.filter('padded', (value, character, times) => {
      return padStart(value, times, character)
    })

    Vue.filter('truncate', (content, length, clamp) => {
      clamp = clamp || '...'
      return content.length > length ? content.slice(0, length) + clamp : content
    })

    Vue.filter('humanize', (value) => {
      return value.replace('_', ' ')
    })

    Vue.filter('sentenceCase', (value) => {
      if (value === null || value === undefined) {
        return value
      }
      let newValue = value.replace(/_/g, ' ')
      newValue = newValue.charAt(0).toUpperCase() + newValue.slice(1)
      return newValue
    })

    Vue.filter('titleCase', (value) => {
      if (value === null || value === undefined) {
        return value
      }

      let newValue = value.replace(/_/g, ' ')
      newValue = newValue.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase())
      return newValue
    })

    Vue.filter('phoneNumber', (value, regionShortname = null) => {
      if (!value) {
        return null
      }
      let phone = parsePhoneNumberFromString(value)
      if (phone && phone.isValid()) {
        return phone.formatInternational()
      }
      if (regionShortname) {
        phone = parsePhoneNumber(value, regionShortname.toUpperCase())
        if (phone.isValid()) {
          return phone.formatInternational()
        }
      }
      return value
    })
  }
}
